import { render, staticRenderFns } from "./FinalDetails2.vue?vue&type=template&id=eb805db0&scoped=true&"
import script from "./FinalDetails2.vue?vue&type=script&lang=ts&"
export * from "./FinalDetails2.vue?vue&type=script&lang=ts&"
import style0 from "./FinalDetails2.vue?vue&type=style&index=0&id=eb805db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb805db0",
  null
  
)

export default component.exports